module.exports = __webpack_public_path__ + "img/mengHu2.0e027cbe.png";